exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".donations-progress .progress-sum-block{padding:23px 0 20px;margin:0 0 1px 3px;border:1px dashed #d1d1d1;border-radius:4px;background-color:#ececec;color:#803a78;font-size:70px;line-height:50px;font-weight:300;text-align:center}.donations-progress .progress-sum-block .currency{font-size:21px;font-weight:700}.donations-progress .progress-sum-block .commitmens-total{font-size:14px;line-height:20px;margin-top:10px;color:#4e4e4e}.donations-progress .progress-sum-block .commitmens-total span{color:#803a78;margin:0 4px}.donations-progress .progress-summary{text-align:center;margin:11px auto 0;color:#4e4e4e;font-size:26px;font-weight:300}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/donations-progress/donations-progress.scss
// module id = 496
// module chunks = 0